// src/utils/teamUtils.ts
import rawTeamNameMap from '../data/teamNameMap.json';

// Create a properly typed version of the team name map
const teamNameMap: Record<string, string> = rawTeamNameMap as Record<string, string>;

/**
 * Normalizes a team name for comparison purposes
 */
export const normalizeTeamNameForComparison = (teamName: string): string => {
  if (!teamName) return '';
  // Remove spaces, periods, apostrophes and convert to uppercase
  return teamName.toUpperCase().replace(/[\s'.]/g, '');
};

/**
 * Normalizes team names for display purposes using teams.txt as the source of truth
 * Falls back to standard normalization rules for unknown teams
 */
export const normalizeTeamNameForDisplay = (teamName: string): string => {
  if (!teamName) return '';
  
  // Normalize the input name for lookup
  const normalizedName = normalizeTeamNameForComparison(teamName);
  
  // Type-safe lookup in the map
  if (normalizedName in teamNameMap) {
    return teamNameMap[normalizedName];
  }
  
  // If not found in our map, apply standard normalization rules
  
  // Handle special abbreviations that should remain as-is
  if (/^[A-Z]{2,5}$/.test(teamName)) {
    // Short abbreviations (2-5 letters) remain uppercase
    return teamName;
  }
  
  // If currently all uppercase and longer than 2 characters, convert to proper case
  if (teamName === teamName.toUpperCase() && teamName.length > 2) {
    return teamName
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
  
  // Otherwise, return as-is
  return teamName;
};